import { InMemoryCache, makeVar } from '@apollo/client';
import { CustomError } from 'apollo/types';
import { PurchaseData } from 'storage/types';
import { readStoredPurchase } from 'storage/utils/purchaseStorage';
import { EntranceTicketType, Pack } from './generated/types';

export const useMocksCache = makeVar<boolean>(false);
export const showErrorModal = makeVar<boolean>(false);
export const errorData = makeVar<CustomError | null>(null);
export const selectedItem = makeVar<Pack | EntranceTicketType | null>(null);

// MainLayout renders outside the Router, so it cannot read the route to decide this.
export const hideNavBar = makeVar<boolean>(false);

// The purchase cart. sessionStorage is only where it persists — this var is the owner
// components subscribe to. Write it through storage/purchaseStore, never directly.
export const purchaseVar = makeVar<PurchaseData | null>(readStoredPurchase());

// Localized entities are not normalized by id: the same id returns different content per
// language, so a normalized entity would be overwritten on a language switch.
const cache = new InMemoryCache({
  typePolicies: {
    NewsPost: {
      keyFields: false,
    },
    SummaryPack: {
      keyFields: false,
    },
    Pack: {
      keyFields: false,
    },
    EntranceTicketType: {
      keyFields: false,
    },
  },
});

export default cache;
